import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  message,
  InputNumber,
  Select,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getPackageById,
  updatePackage,
} from "../../redux/Packages/PackagesActions";
import { useLocation } from "react-router-dom";
import { getFeatures } from "../../redux/Features/FeaturesActions";

const EditPackage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const userData = useSelector((state) => state.Auth.userData);
  const packageById = useSelector((state) => state.PackagesReducer.packageById);
  const sidebarFetch = useSelector(
    (state) => state.PackagesReducer.sidebarFetch
  );
  const getFeaturesData = useSelector(
    (state) => state.FeaturesReducer.getFeaturesData
  );

  const [checked, setChecked] = useState(false);
  const [isActive, setisActive] = useState(false);
  const [activePermissions, setActivePermissions] = useState([]);

  useEffect(() => {
    dispatch(getFeatures({ _id: userData?._id }));
  }, []);

  useEffect(() => {
    if (userData && location?.state?.data?.planTypeId) {
      let data = {
        _id: userData?._id,
        packageId: location?.state?.data?.planTypeId,
      };
      dispatch(getPackageById(data));
    }
  }, [location]);

  useEffect(() => {
    const permissions = getFeaturesData?.filter(
      (permissions) => permissions.status === true
    );
    setActivePermissions(permissions);
  }, [getFeaturesData]);

  useEffect(() => {
    if (packageById) {
      setChecked(packageById?.status || false);
      setisActive(packageById?.isActive || false);
      form.setFieldsValue({
        packageTitle: packageById?.title || "",
        packageSku: packageById?.sku || "",
        packagePrice: packageById?.price || 0,
        packageDuration: packageById?.duration || 0,
        brandCount: packageById?.brandCount || 0,
        userCount: packageById?.userCount || 0,
        packageDescription: packageById?.description || "",
        subTitle: packageById?.subTitle || "",
        shortDesc: packageById?.shortDesc || "",
        permissions: packageById?.permissions?.map((p) => p?._id) || [],
      });
    }
  }, [packageById, form]);

  const submitHandler = (values) => {
    const data = {
      _id: userData?._id,
      packageStatus: checked,
      packageId: packageById._id,
      planTypeId: packageById.planTypeId,
      packageTitle: values?.packageTitle,
      packageSku: values?.packageSku,
      packagePrice: values?.packagePrice,
      packageDuration: values?.packageDuration,
      brandCount: values?.brandCount,
      userCount: values?.userCount,
      packageDescription: values?.packageDescription,
      subTitle: values?.subTitle,
      shortDesc: values?.shortDesc,
      permissions: values?.permissions,
    };
    dispatch(updatePackage(data, navigateAfterSuccess));
  };

  const onCheckboxValueChange = (e) => {
    if (e.target.checked) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  };
  const onCheckboxBestValue = (e) => {
    if (e.target.checked) {
      setisActive(true);
    } else {
      setisActive(false);
    }
  };

  const navigateAfterSuccess = () => {
    message.success("Successfully Updated");
    navigate("/packages", { state: { data: packageById.planTypeId } });
  };

  const optionsPermission =
    activePermissions?.map((item) => ({
      label: item.title,
      value: item._id,
    })) || [];

  return (
    <>
      <Breadcrumb
        className="breadCrumb"
        items={[
          { title: "Plans & Packages" },
          { title: "Packages" },
          { title: "Edit Package" },
        ]}
      />
      <Row className="addShortcut">
        <Col span={24}>
          <div>
            <Form
              form={form}
              name="control-hooks"
              labelCol={{ span: 3 }}
              layout="horizontal"
              className="ticketForm"
              onFinish={submitHandler}
              onFinishFailed={(errorInfo) => {
                console.error("Form Submission Failed:", errorInfo);
              }}
            >
              <Form.Item
                name="packageSku"
                wrapperCol={{ span: 8 }}
                label="SKU"
                rules={[
                  {
                    required: true,
                    message: "Please enter SKU!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="packageTitle"
                wrapperCol={{ span: 8 }}
                label="Title"
                rules={[
                  {
                    required: true,
                    message: "Please enter package title!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="subTitle"
                wrapperCol={{ span: 8 }}
                label="Sub Title"
                rules={[
                  {
                    required: true,
                    message: "Please enter package sku!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="shortDesc"
                wrapperCol={{ span: 12 }}
                label="Short Description"
                rules={[
                  {
                    required: true,
                    message: "Please enter package short description!",
                  },
                ]}
              >
                <TextArea rows={3} />
              </Form.Item>
              <Form.Item
                name="packagePrice"
                wrapperCol={{ span: 8 }}
                label="Price"
                rules={[
                  {
                    required: true,
                    type: "number",
                    message: "Please enter package price!",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                name="brandCount"
                wrapperCol={{ span: 8 }}
                label="Brands (No. of brands)"
                rules={[
                  {
                    required: true,
                    type: "number",
                    message: "Please enter package brands count!",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                name="packageDuration"
                wrapperCol={{ span: 8 }}
                label="Duration (In Days)"
                rules={[
                  {
                    required: true,
                    type: "number",
                    message: "Please enter package duration!",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                name="userCount"
                wrapperCol={{ span: 8 }}
                label="Users (No. of users)"
                rules={[
                  {
                    required: true,
                    type: "number",
                    message: "Please enter package users count!",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item wrapperCol={{ span: 8 }} label="Package Status">
                <Checkbox
                  name="packageStatus"
                  id="packageStatus"
                  checked={checked}
                  onChange={onCheckboxValueChange}
                >
                </Checkbox>
              </Form.Item>

              {/* <Form.Item wrapperCol={{ span: 8 }} label="isActive">
                <Checkbox
                  name="packageStatus"
                  id="packageStatus"
                  checked={isActive}
                  onChange={onCheckboxBestValue}
                >
                  Enable Package
                </Checkbox>
              </Form.Item> */}
              <Form.Item
                name="packageDescription"
                wrapperCol={{ span: 12 }}
                label="Description"
                rules={[
                  {
                    required: true,
                    message: "Please enter package description!",
                  },
                ]}
              >
                <TextArea rows={3} />
              </Form.Item>
              <Form.Item
                name="permissions"
                wrapperCol={{ span: 12 }}
                label="Permissions"
                rules={[
                  {
                    required: true,
                    message: "Please enter package permissions!",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="Tags Mode"
                  options={optionsPermission}
                />
              </Form.Item>

              <div className="topbtn">
                <Button
                  className="back-btn"
                  onClick={() =>
                    navigate("/packages", {
                      state: { data: packageById.planTypeId },
                    })
                  }
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  className="align-right"
                  htmlType="submit"
                >
                  Update
                </Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default EditPackage;
